import { RequestExcusableStatus } from "./../../../../src/Enums/RequestExcusableStatus";
import { RequestExcusableType } from "../../../../src/Enums/RequestExcusableType";
import { RequestExcusableShippingType } from "../../../../src/Enums/RequestExcusableShippingType";

export const SourceExcusable = "requestorderexcusables";
export const SourceExcusableRbh = "requestordersexcusables/rbh/detail";
export const SourceExcusableReasonList = "requestorderexcusables";
export const SourceExcusableReasonEdit = "requestorderexcusablehistorys";

export const TitleExcusable = {
  list: "Excusable List",
  edit: "Edit Excusable",
  create: "Create Excusable",
};

export const shippingTypes = [
  { id: RequestExcusableShippingType.Serviceable, label: "Serviceable" },
  { id: RequestExcusableShippingType.Unserviceable, label: "Core Unit" },
];
export const excusableTypes = [
  { id: RequestExcusableType.Normal, label: "Normal" },
  { id: RequestExcusableType.NFF, label: "NFF" },
  { id: RequestExcusableType.CID, label: "CID" },
];
export const excusableStatus = [
  { id: RequestExcusableStatus.Accepted, label: "Accepted" },
  { id: RequestExcusableStatus.Opened, label: "Opened" },
  { id: RequestExcusableStatus.Rejected, label: "Rejected" },
  { id: RequestExcusableStatus.UnderDispute, label: "UnderDispute" },
  {
    id: RequestExcusableStatus.PartiallyAccepted,
    label: "Partially Accepted",
  },
];
